<template>
  <sui-page>
    <sui-page-header :title="$t('MSG_TIT_ANNM_MDFC')" />
    <sui-page-contents>
      <div class="comm_view_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_BBS_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-11">
            <div class="comm_label">
              {{ bbsName }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_TITLE')"
              :vertical="false"
              required
            />
          </div>
          <div class="col-xs-11">
            <sui-text-field
              v-model.trim="boardTitle"
              placeholder=""
              :disabled="false"
              max-length="4000"
              :readonly="false"
            />
          </div>
        </div>
        <div class="row">
          <div
            v-if="isCategoryGroupExist"
            class="col-xs-1"
          >
            <sui-input-label
              :label="$t('MSG_TXT_CATG')"
              :vertical="false"
              required
            />
          </div>
          <div
            v-if="isCategoryGroupExist"
            class="col-xs-3"
          >
            <sui-select-box
              v-model="selectedCategory"
              :option-list="categoryOptions"
              placeholder="select"
              required
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_VALID_PERIOD')"
              :vertical="false"
              required
            />
          </div>
          <div
            v-if="selectedRange.to"
            class="col-xs-3"
          >
            <sui-range-date-picker
              ref="rangeDate"
              v-model="selectedRange"
              @confirm="onChangedPeriodDT"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_NOTICOBJ_TYPE')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-3">
            <sui-checkbox v-model="emergency">
              {{ $t('MSG_TXT_UGRN') }}
            </sui-checkbox>
            <div class="comp_spacing" />
            <sui-checkbox v-model="notice">
              {{ $t('MSG_TXT_ANNM') }}
            </sui-checkbox>
          </div>
        </div>
      </div>
      <div class="mrB10" />
      <sui-web-editor
        ref="myEditor"
        :isViewer="false"
        class="width100"
        @loaded="retrieveDetails"
      />
      <div class="mrB10" />
      <cmp-file-attacher
        ref="fileAttacher"
        :pageId="this.$options.name"
        :attachDocumentId="attachDocumentId"
        :attachGroupId="'ATG_CLB_BBS_COMMON'"
        :customAttachRestrictionSize="attachRestrictSize"
      />
    </sui-page-contents>
    <sui-page-footer>
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onCancel"
        >
          {{ $t('MSG_BTN_CLOSE') }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="validateAnouncementData('tempRegister')"
        >
          {{ $t('MSG_BTN_TMP_SAVE') }}
        </sui-button>
        <sui-button
          v-permission:create="this.$options.name"
          type="button"
          class="comm_btn_solid"
          @click="validateAnouncementData('register')"
        >
          {{ $t('MSG_BTN_RGST') }}
        </sui-button>
      </div>
    </sui-page-footer>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CLB_00012', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
    },
    pageInitialData: {
      type: Object,
    },
  },
  data() {
    return {
      isWebEdtrInitialized: false,
      bbsName: '',
      bbsId: '',
      fileList: [],
      boardTitle: '',
      selectedRange: {},
      retrievedData: {},
      attachDocumentId: '',
      selectedCategory: {},
      showRegPopup: false,
      categoryOptions: [],
      uploadedFile: '',
      emergency: false,
      notice: false,
      editorContent: '',
      applicationUserId: this.$store.getters.userInfo.userName,
      isCategoryGroupExist: false,
      attachRestrictSize: 0,
    };
  },
  computed: {},
  watch: {},
  datasets: [],
  beforeMount() {
  },
  mounted() {
    this.getBBName();
    this.retrieveDetails();
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    getBBName() {
      this.bbsName = this.pageInitialData.bbsName;
      this.bbsId = this.pageInitialData.bbsId;
      this.isCategoryGroupExist = this.pageInitialData.isCategoryGroupExist;
      this.attachRestrictSize = this.pageInitialData.attachRestrictSize;
      this.tbabRestrictSize = this.pageInitialData.tbabRestrictSize;
      if (this.isCategoryGroupExist) {
        this.categoryItems();
      }
    },
    retrieveDetails() {
      const pathParam = {
        'post-id': this.pageInitialData.postIdParam,
      };
      http.request('PGE_CLB_00002', 'DTS_CLB_00004', {
        path: pathParam,
      }).then(res => {
        this.boardTitle = res.data[0].annNoticeObjTitle;
        this.editorContent = res.data[0].annNoticeObjContent;
        this.selectedCategory = {
          key: res.data[0].bbsCategoryItemId,
          label: res.data[0].bbsCategoryItemNm,
        };
        this.selectedRange.from = utils.toStringByFormat(res.data[0].validStartDtm, 'YYYY-MM-DD');
        this.selectedRange.to = utils.toStringByFormat(res.data[0].validFinishDtm, 'YYYY-MM-DD');
        this.bbsCatgGrpItemName = res.data[0].bbsCatgGrpItemName;
        this.notice = res.data[0].annYN === 'Y' ? true : false;
        this.emergency = res.data[0].urgnYN === 'Y' ? true : false;
        this.usrId = res.data[0].usrId;
        this.attachDocumentId = res.data[0].atthDocId;
        this.$refs.myEditor.setHtml(this.editorContent);
      }).catch(err => {
        console.log(err);
      });
    },
    onChangedPeriodDT() {

    },
    // Get prefilled default date
    getDefaultDate() {
      const pathParams = {
        'bulletin-board-id': this.bbsId,
      };
      http.request('PGE_CLB_00011', 'DTS_CLB_00051', {
        path: pathParams,
      })
        .then(res => {
          if (res.data && res.data[0]) {
            const startDate = res.data[0].vldStrtdt;
            const endDate = res.data[0].vldFinishdt;
            this.frame0.periodDT.from = startDate.slice(0, 4) + '-' + startDate.slice(4, 6)+ '-' + startDate.slice(6, 8);
            this.frame0.periodDT.to = endDate.slice(0, 4) + '-' + endDate.slice(4, 6)+ '-' + endDate.slice(6, 8);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    categoryItems() {
      http.request('PGE_CLB_00012', 'DTS_CLB_00050', {
        path: {
          'bulletin-board-id': this.bbsId,
        },
      }).then(res => {
        if (res.data) {
          const optionList = res.data;
          let i;
          for (i = 0; i < optionList.length; i++) {
            optionList[i].label = optionList[i]['bbsCatgItemNm'];
            optionList[i].key = optionList[i]['bbsCatgItemId'];
            delete optionList[i].bbsCatgItemId;
            delete optionList[i].bbsCatgItemNm;
            this.categoryOptions = optionList;
          }
        }
      });
    },
    onPopupCancelClicked() {
      this.showRegPopup = false;
    },
    // Reset attachment
    onResetFileAttacher() {
      this.$refs.fileAttacher.reset();
    },
    getFileListInfo() {
      this.fileList = this.$refs.fileAttacher.getAttachGroupItemListInfo();
      if (this.fileList && this.fileList[0].attachFileList.length > 0 && !this.attachDocumentId) {
        this.attachDocumentId = this.pageInitialData.postIdParam;
      }
    },
    /* Get attachment id first
    TODO: Mapping is not done.
    */
    getAttachDocumentId() {
      const pathParams = {
        'bulletin-board-id': this.bbsId,
      };

      http.request('PGE_CLB_00012', 'DTS_CLB_00007', {
        path: pathParams,
      }).then(res => {
        this.attachDocumentId = res.data.atthDocId;
      });
    },
    // Validate Announcement before registration
    /* TODO : Update with messageID */
    validateAnouncementData(type) {
      this.editorContent = this.$refs.myEditor.getHtml();
      this.getFileListInfo();
      if (!this.boardTitle) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_INPUT_CELL'), this.$t('MSG_TXT_TITLE'), null));
        return false;
      }
      if (!this.selectedCategory) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_INPUT_CELL'), this.$t('MSG_TXT_CATG_GRP_ITEM'), null));
        return false;
      }
      if (!this.editorContent || this.$refs.myEditor.getText().trim().length === 0) {
        utils.messageBox('warning', utils.strFormat(this.$t('MSG_ALT_INPUT_CELL'), this.$t('MSG_ALT_ROW_INPUT_CONTENT'), null));
        return false;
      }
      if (!this.checkContentSize()) {
        const msg = utils.strFormat(this.$t('MSG_ALT_SIZE_LIMIT_EXCEEDED'), this.tbabRestrictSize);
        utils.messageBox('warning', msg);
        return false;
      }
      if (type === 'register') {
        utils.messageBox('confirm', this.$t('MSG_ALT_RGST'), null, this.registerAnnouncement);
      }
      if (type === 'tempRegister') {
        utils.messageBox('confirm', this.$t('MSG_ALT_PRSS_TMP_SAVE'), null, this.tempRegisterAnnouncement);
      }
    },
    registerAnnouncement() {
      const pathParam = {
        'post-id': this.pageInitialData.postIdParam,
      };
      let dataParams = {};
      dataParams = {
        annNoticeObjApprovalStatusCode: this.approveUseYn === 'Y' ? 'R' : 'P',
        annNoticeObjContent: this.editorContent,
        annNoticeObjTitle: this.boardTitle,
        annYN: this.notice ? 'Y' : 'N',
        tmpSaveYN: 'N',
        atthDocId: this.attachDocumentId,
        bbsCategoryItemId: this.selectedCategory.key,
        bbsId: this.bbsId,
        bbsLogDeptId: '',
        bbsLogTypeCd: 'C',
        urgnYN: this.emergency ? 'Y' : 'N',
        firstRegistrationUserId: this.applicationUserId,
        validFinishDtm: utils.toStringByFormat(this.selectedRange.to, 'YYYYMMDD')  + '235959',
        validStartDtm: utils.toStringByFormat(this.selectedRange.from, 'YYYYMMDD') + '000000',
        attachFileList: this.fileList && this.fileList[0].attachFileList ? this.fileList[0].attachFileList : [],
      };

      http.request('PGE_CLB_00012', 'DTS_CLB_00005', {
        path: pathParam,
        data: dataParams,
      })
        .then(res => {
          if (res.data.resultCode === '1') {
            utils.messageBox('success', this.$t('MSG_ALT_PRGS_OK'), null, null);
            this.onCancel();
            this.updateLogs(this.pageInitialData.postIdParam, 'U');
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    tempRegisterAnnouncement() {
      const pathParam = {
        'post-id': this.pageInitialData.postIdParam,
      };
      let dataParams = {};
      dataParams = {
        annNoticeObjApprovalStatusCode: 'D',
        annNoticeObjContent: this.editorContent,
        annNoticeObjTitle: this.boardTitle,
        annYN: this.notice ? 'Y': 'N',
        tmpSaveYN: 'Y',
        atthDocId: this.attachDocumentId,
        bbsCategoryItemId: this.selectedCategory.key,
        bbsId: this.bbsId,
        bbsLogDeptId: '',
        bbsLogTypeCd: 'C',
        urgnYN: this.emergency ? 'Y' : 'N',
        firstRegistrationUserId: this.applicationUserId,
        validFinishDtm: utils.toStringByFormat(this.selectedRange.to, 'YYYYMMDD') + '235959',
        validStartDtm: utils.toStringByFormat(this.selectedRange.from, 'YYYYMMDD') + '000000',
        attachFileList: this.fileList && this.fileList[0].attachFileList ? this.fileList[0].attachFileList : [],
      };

      http.request('PGE_CLB_00012', 'DTS_CLB_00005', {
        path: pathParam,
        data: dataParams,
      })
        .then(res => {
          if (res.data.resultCode === 1) {
            utils.messageBox('information', this.$t('MSG_ALT_PRGS_OK'), null, null);
            this.onCancel();
            this.updateLogs(this.pageInitialData.postIdParam, 'U');
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //log history API
    updateLogs(postId, type) {
      const pathParam = {
        'post-id': postId,
      };
      http.request('PGE_CLB_00002', 'DTS_CLB_00061', {
        path: pathParam,
        data: {
          bbsLogDeptId: this.$store.getters.userInfo.departmentId,
          firstRegistrationProgramId: this.pageInitialData.pageId,
          firstRegistrationUserId: this.usrId,
          bbsLogTypeCd: type,
          bbsId: this.bbsId,
        },
      }).then(() => {
      });
    },
    onCancel() {
      this.closePagePopup(true);
    },
    checkContentSize() {
      return this.tbabRestrictSize >= this.$refs.myEditor.getContentSize();
    },
  },
};
</script>
<style scoped>
</style>
